export default __webpack_public_path__ + "static/media/admin.f90f5315.png";